import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Hook para restablecer estado desde localStorage
export const useStateHydration = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const hasHydrated = useRef(false);

  useEffect(() => {
    if (hasHydrated.current) return;
    hasHydrated.current = true;

    if (isAuthenticated) return;

    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        if (parsedUser && parsedUser.type && parsedUser.logg_express) {
          dispatch({ type: 'auth/restoreAuth', payload: parsedUser });
          dispatch({ type: 'ui/setUserTypeTheme', payload: parsedUser.type });
        } else {
          localStorage.removeItem('user');
        }
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
        localStorage.removeItem('user');
      }
    }
  }, [dispatch, isAuthenticated]);
};
